const AuthenticationDefaultSteps={
    CREATE_PAYMENT:'CreatePayment',
    SET_ITEMS:'SetItems',
    PAYMENT_INQUIRY:'InquiryPayment',
    SHAHKAR:'Shahkar',
    BUSINESS_LICENSE_INQUIRY:'BusinessLicenseInquiry',
    BUSINESS_OTP:"BusinessLicenseOTP",
    AUTO_NID_CARD:"AutoNIDCard",
    LAWYER_INQUIRY:'LawyerInquiry',
    EXPERT_INQUIRY:'ExpertInquiry',
    INIT_CONFIRM:'InitConfirm',
    NID_CARD_READER:"NIDCardReader",
    POLICE_CLEARANCE_RESULT:"PoliceClearanceResult",
    COMPARE_FACES:"CompareFaces",
    VIDEO_VALIDATION:"VideoValidation",
    POLICE_CLEARANCE_INQUIRY:"PoliceClearanceInquiry",
    POLICE_CLEARANCE:"PoliceClearance",
    IAuth:"IAuth",
    FINAL:"Final",

}
const DefaultTexts = {
    "InitConfirm":{
        title:"تکمیل اطلاعات"
    },
    "CreatePayment":{
        title:"پرداخت"
    },
    "PaymentInquiry":{
        title:"پرداخت"
    },
    "NIDCardReader": {
        title:"عکس کارت ملی"
    },
    "Shahkar": {
        title:"ساخت فرایند جدید"
    },
    "CompareFaces": {
        title:"احراز هویت تصویری"
    },
    "VideoValidation": {
        title:"احراز هویت ویدیویی"
    },

};

export {AuthenticationDefaultSteps,DefaultTexts}